import {toast} from 'react-toastify';

const INITIAL_STATE = {
  todos: [],
  carregando: false,
  erro: null
};

export default (state = INITIAL_STATE, action) => {
  switch(action.type){
    case 'REQUISITAR_FORMANDO':
      return {...state, carregando: true};
    case 'ERRO_FORMANDO':
      toast.error(action.erro.message, {autoClose: false});
      return {...state, carregando: false, erro: action.erro};
    case 'OBTER_TODOS_FORMANDOS':
      return {...state, carregando: false, todos: action.formandos};
    case 'OBTER_PELO_CONTRATO':
      return {...state, carregando: false, todos: action.formandos};
    case 'NOVO_FORMANDO':
      toast.success("Formando cadastrado com sucesso.", 5000);
      return {...state, carregando: false, todos: state.todos.concat(action.formando)};
    case 'ALTERAR_FORMANDO':
      //toast.success("Formando alterado com sucesso.", 5000);
      return {...state, carregando: false};
    case 'REMOVER_FORMANDO':
      toast.success("Formando removido com sucesso.", 5000);
      return {...state, carregando: false, todos: state.todos.filter((formando) => {return formando.id!==action.id})};
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/FormandoReducer.js